export default {"src":"/_next/static/media/shopping_center_overview_3.5ee00046.gif","height":400,"width":700,"blurWidth":0,"blurHeight":0};